import { useEffect, useState } from 'react'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

import './style.scss';
import { UserPost } from '../../types/posts';
import AppUserPost from '../../components/app_userPost/AppUserPost';
import { useAppSelector } from '../../redux/hooks';
import AppPost from '../../components/app_post/AppPost';
import AppPostButton from '../../components/app_postButton/AppPostButton';

function AppCommunity() {

	const showNewPost = useAppSelector((state) => state.user.showNewPost)

	const [communityName, setCommunityName] = useState<string>('')
	const [bioExpanded, setBioExpanded] = useState<boolean>(false)
	const [bioText, setBioText] = useState<string>('')

	const [showingReels, setShowingReels] = useState<boolean>(true)

	const [userPosts, setUserPosts] = useState<UserPost[]>([])

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn === false) {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		} else {
			// Load profile data
			// setBioText('Thisis the users Bio section where they can write a little about who they are. The text will appears cut off until it is expanded by clicking the show more button')
			getProfileData()
		}
	}, [])

	const getProfileData = () => {
		setCommunityName('Community Name')
		setBioText('This is an example Community about us text exntry used for testing data transfer and front-end layout')

		// Fake post
		// const fakePost: UserPost = {
		// 	postId: '6666',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'This is an example fake post used for testing the front end layout',
		// 	postImgSrc: undefined,
		// 	verified: true
		// }
		// const fakePost2: UserPost = {
		// 	postId: '66626',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'This is an example fake post with an image',
		// 	postImgSrc: userStateData.getUserIconUrl(),
		// 	verified: true
		// }
		// const fakePost3: UserPost = {
		// 	postId: '6666',
		// 	sourceName: 'Test User',
		// 	community: 'Community Name',
		// 	sourceImgSrc: userStateData.getUserIconUrl() || '',
		// 	postDate: 0,
		// 	postMsg: 'Another fake post to test stacked posts in layout',
		// 	postImgSrc: undefined,
		// 	verified: true
		// }
		const fakePost: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post used for testing the front end layout',
			postImgSrc: undefined,
			verified: true
		}
		const fakePost2: UserPost = {
			postId: '66626',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'This is an example fake post with an image',
			postImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl(),
			verified: true
		}
		const fakePost3: UserPost = {
			postId: '6666',
			sourceName: 'Test User',
			community: 'Community Name',
			sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
			postDate: 0,
			postMsg: 'Another fake post to test stacked posts in layout',
			postImgSrc: undefined,
			verified: true
		}
		setUserPosts([fakePost, fakePost2, fakePost3])
	}

	return (
		<>
			<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-community-page-full-section'>
				<div className='app-community-page-top-section-wrap'>
					<div className='app-community-page-top-section'>
						<div className='app-community-page-top-section-hero-image' />
						<div
							className='app-community-page-img-wrap'
						>
							<img 
								className='app-community-page-img'
								src={'/imgs/temp/community/temp-icon.png'}
								alt='Profile'
							/>
						</div>
						<a
							href={PAGE_URLS.APP_COMMUNITIES}
							className='app-community-page-back-button'
						>
							<img
								src='/imgs/icons/shared/icon-instructor-shared-button.svg'
								alt='Back'
							/>
						</a>
					</div>
				</div>
				<div className='app-community-page-bio-section-wrap'>
					<div className='app-community-page-top-name-wrap'>
						<div className='app-community-page-top-name'>{communityName}</div>
					</div>
					<div className='app-community-page-friend-wrap'>
						<div className='app-community-page-friend-icon' />
						<div className='app-community-page-friend-icon' />
						<div className='app-community-page-friend-icon' />
						<div className='app-community-page-friend-label'>+ Members</div>
					</div>
					<div 
						className='app-community-page-tag-line'
					>Tag Line</div>
					<div 
						className='app-community-page-bio-text'
					>
						{bioText.length > 1 ? 
							<>
								{bioExpanded ? bioText : `${bioText.substring(0, 20)} ... `}
								{bioExpanded === false && 
									<div 
										className='app-community-page-bio-show-more'
										onClick={() => {
											setBioExpanded(true)
										}}
									>see more</div>
								}
							</> :
							<>No Bio Provided</>
						}
					</div>
					<div className='app-community-page-action-button-wrap'>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-join.svg'
									alt='Join'
								/>
							</div>
							<div className='app-community-page-action-button-label app-community-page-action-button-label-branded'>
								Join
							</div>
						</div>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-info.svg'
									alt='Info'
								/>
							</div>
							<div className='app-community-page-action-button-label'>Info</div>
						</div>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-share.svg'
									alt='Share'
								/>
							</div>
							<div className='app-community-page-action-button-label'>Share</div>
						</div>
						<div className='app-community-page-action-button'>
							<div className='app-community-page-action-button-icon'>
								<img
									className='app-community-page-action-button-icon'
									src='/imgs/icons/community/icon-community-more.svg'
									alt='More'
								/>
							</div>
							<div className='app-community-page-action-button-label'>More</div>
						</div>
					</div>
					<div className='app-community-page-switch-wrap'>
						<div 
							className={`app-community-page-switch-button ${showingReels === true ? 'app-community-page-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(true)
							}}
						>
							<div
								className='app-community-page-switch-label'
							>Feed</div>
						</div>
						{/* <div className='app-community-page-switch-button'> */}
						<div 
							className={`app-community-page-switch-button ${showingReels === false ? 'app-community-page-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(false)
							}}
						>
							<div
								className='app-community-page-switch-label'
							>Groups</div>
						</div>
					</div>
				</div>
				<div className='app-community-page-content-section-wrap'>
					{showingReels ? 
						<>
							{userPosts.length > 0 ?
								userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
								:
								<div className='app-community-page-content-section-empty-text'>
									<div className='app-community-page-content-section-empty-text-title'>You haven't posted anything yet...</div>
									<div className='app-community-page-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
								</div>
							}
						</>
						:
						<div className='app-community-page-content-section-empty-text'>
							<div className='app-community-page-content-section-empty-text-title'>You haven't joined yet...</div>
							<div className='app-community-page-content-section-empty-text-sub-text'>Get started by going to communities<br/>and joining a group!</div>
						</div>
					}
				</div>
			</div>
			<BackToTopButton />
			<AppPostButton />
			<AppFooter activeIndex={1} />
			{showNewPost && <AppPost />}
		</>
	)
}

export default AppCommunity
